<div class="container-fluid main-card">
    <div class="row">
        <div class="col-12">
            <h1>
                Mes préférences
                <span>Paramétrez les valeurs par défaut de vos futures simulations</span>
            </h1>
        </div>
        <div class="col-lg-12">
            <div class="row">
                <div class="colWidget col-xl-4 col-lg-6"
                     [stepContent]="userDefaultStepContent"
                     [joyrideStep]="'userDefaultStep'">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card block">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h2>Gestion</h2>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Gestion en agence <i class="fa fa-info-circle" matTooltip="Le taux moyen pour une gestion locative en agence est de 7%."></i></mat-label>
                                                <input type="number" step="0.5" matInput [(ngModel)]="user.agence"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>%</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Frais de relocation par agence <i class="fa fa-info-circle" matTooltip="Lorsque vous avez un changement de locataire, l'agence immobilière va facturer des frais pour faire les visites et les états des lieux. Ces frais correspondent en moyenne à 1 mois de loyer charges comprises."></i></mat-label>
                                                <input type="number" step="0.5" matInput [(ngModel)]="user.agence_rental"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>%</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Garantie loyers impayés <i class="fa fa-info-circle" matTooltip="Le coût d'une Garantie Loyers Impayés (GLI) est en moyenne de 3%."></i></mat-label>
                                                <input type="number" step="0.5" matInput [(ngModel)]="user.amount_rent_insurance"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>%</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Assurance PNO <i class="fa fa-info-circle" matTooltip="L'assurance PNO (Propriétaire Non Occupant) vous couvre en cas de dégradations qui ne seraient pas prises en charges par l'assurance habitation de votre locataire."></i></mat-label>
                                                <input type="number" step="10" matInput [(ngModel)]="user.building_insurance"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€/lots</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Vacance locative <i class="fa fa-info-circle" matTooltip="Le nombre de mois ou votre logement sera vide chaque année (peut arriver entre 2 locataires par exemple). Dans le cas d'un immeuble, cela s'applique à chacun des lots."></i></mat-label>
                                                <input type="number" step="0.5" matInput [(ngModel)]="user.rental_vacancy"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>mois/an</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Autres frais <i class="fa fa-info-circle" matTooltip="Entretien, provision pour travaux, charges non prévues ..."></i></mat-label>
                                                <input type="number" step="100" matInput [(ngModel)]="user.other_bill"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€/lots</span>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card block">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h2>Travaux</h2>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Calcul</mat-label>
                                                <mat-select disableOptionCentering [(ngModel)]="user.default_work"
                                                            (ngModelChange)="edit($event)">
                                                    <mat-option [value]="0">Montant fixe</mat-option>
                                                    <mat-option [value]="1">Montant €/m²</mat-option>
                                                    <mat-option [value]="2">Montant par lots</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Montant travaux</mat-label>
                                                <input type="number" step="10" matInput [(ngModel)]="user.default_work_value"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix *ngIf="user.default_work == 0">€</span>
                                                <span matSuffix *ngIf="user.default_work == 1">€/m²</span>
                                                <span matSuffix *ngIf="user.default_work == 2">€/lots</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-12">
                                            <h4>Montant rénovation</h4>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field>
                                                <mat-label>Rafraichissement</mat-label>
                                                <input type="number" step="10" matInput [(ngModel)]="user.work_1"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€/m²</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field>
                                                <mat-label>Rénovation</mat-label>
                                                <input type="number" step="10" matInput [(ngModel)]="user.work_2"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€/m²</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field>
                                                <mat-label>Remise à neuf</mat-label>
                                                <input type="number" step="10" matInput [(ngModel)]="user.work_3"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€/m²</span>
                                                <mat-hint><br/></mat-hint>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="colWidget col-xl-4 col-lg-6"
                     [stepContent]="userFinanceStepContent"
                     [joyrideStep]="'userFinanceStep'">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card block">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h2>Financement</h2>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Apport</mat-label>
                                                <mat-select disableOptionCentering [(ngModel)]="user.apport_notary"
                                                            (ngModelChange)="edit($event)">
                                                    <mat-option [value]="1">Frais de notaire
                                                    </mat-option>
                                                    <mat-option [value]="0">Montant fixe</mat-option>
                                                    <mat-option [value]="2">Pourcentage</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field
                                                [hidden]="user.apport_notary == 1">
                                                <mat-label>Montant apport <i class="fa fa-info-circle" matTooltip="Montant de votre apport dans ce projet. Si l'apport est à 0, cela signifie que vous faites votre crédit sur la totalité du projet : Achat, travaux, mobilier, notaire, frais bancaires ..."></i></mat-label>
                                                <input type="number" step="1000" matInput [(ngModel)]="user.apport"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix *ngIf="user.apport_notary == 0">€</span>
                                                <span matSuffix *ngIf="user.apport_notary == 2">%</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Durée <i class="fa fa-info-circle" matTooltip="Durée totale du crédit, même si vous bénéficiez d'un différé de crédit. Ce différé sera pris en compte dans l'onglet &quot;imposition&quot;. Exemple : Pour un crédit de 18 ans + 2 ans de différé, renseignez 20 ans"></i></mat-label>
                                                <input type="number" step="1" matInput [(ngModel)]="user.duration"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>ans</span>
                                                <mat-hint><br/></mat-hint>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Taux du crédit</mat-label>
                                                <input type="number" step="0.1" matInput [(ngModel)]="user.rate"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>%</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-4">
                                            <mat-form-field>
                                                <mat-label>Taux assurance <i class="fa fa-info-circle" matTooltip="Taux de l'assurance emprunteur."></i></mat-label>
                                                <input type="number" step="0.1" matInput [(ngModel)]="user.rate_insurance"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>%</span>
                                                <mat-hint><br/></mat-hint>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field>
                                                <mat-label>Frais bancaire <i class="fa fa-info-circle" matTooltip="Montant des frais bancaires (aussi appelés frais de dossier) et des frais de courtage si nécessaire."></i></mat-label>
                                                <input type="number" step="100" matInput [(ngModel)]="user.banking_fees"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field>
                                                <mat-label>Frais de cautionnement<i class="fa fa-info-circle"
                                                                                    matTooltip="Montant des frais demandés par votre organisme de cautionnement (Crédit logement, SACCEF, CMH ...) ou les frais d’hypothèque."></i>
                                                </mat-label>
                                                <input type="number" step="100" matInput [(ngModel)]="user.deposit_fees"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€/m²</span>
                                                <mat-hint><br/></mat-hint>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card block">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h2>Autres frais</h2>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Comptable</mat-label>
                                                <input type="number" step="100" matInput [(ngModel)]="user.accouting_fees"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€</span>
                                                <mat-hint><br/></mat-hint>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>CFE</mat-label>
                                                <input type="number" step="100" matInput [(ngModel)]="user.cfe_contribution"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€</span>
                                                <mat-hint><br/></mat-hint>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-12">
                                            <h4>Frais de notaire</h4>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Frais de notaire (neuf)</mat-label>
                                                <input type="number" step="0.1" matInput [(ngModel)]="user.notary_new"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>%</span>
                                                <mat-hint>Taux moyen : 8%</mat-hint>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Frais de notaire (ancien)</mat-label>
                                                <input type="number" step="0.1" matInput [(ngModel)]="user.notary_old"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>%</span>
                                                <mat-hint>Taux moyen : 2.5%</mat-hint>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="colWidget  col-xl-4 col-lg-12"
                     [stepContent]="userFiscaStepContent"
                     [joyrideStep]="'userFiscaStep'">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card block">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h2>Votre situation</h2>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <div class="col-md-12">
                                            <mat-form-field>
                                                <mat-label>Choix du régime fiscal</mat-label>
                                                <mat-select disableOptionCentering [(ngModel)]="user.fiscal_choice"
                                                            (ngModelChange)="editFiscal($event)">
                                                    <mat-option value="Foncier forfait">
                                                        Foncier au forfait
                                                    </mat-option>
                                                    <mat-option value="Foncier reel">
                                                        Foncier au réel
                                                    </mat-option>
                                                    <mat-option value="LMNP forfait">
                                                        LMNP au forfait
                                                    </mat-option>
                                                    <mat-option value="LMNP reel">
                                                        LMNP au réel
                                                    </mat-option>
                                                    <mat-option value="SCI IS">
                                                        SCI à l'IS
                                                    </mat-option>
                                                    <mat-option value="SCI IR">
                                                        SCI à l'IR
                                                    </mat-option>
                                                </mat-select>
                                                <mat-hint *ngIf="user.fiscal_choice == ''"
                                                          class="text-red">
                                                    Veuillez renseigner une valeur
                                                </mat-hint>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Nombre de part(s)</mat-label>
                                                <mat-select disableOptionCentering [(ngModel)]="user.shares_number"
                                                            (ngModelChange)="edit($event)">
                                                    <mat-option [value]="1">1</mat-option>
                                                    <mat-option [value]="1.25">1.25</mat-option>
                                                    <mat-option [value]="1.5">1.5</mat-option>
                                                    <mat-option [value]="1.75">1.75</mat-option>
                                                    <mat-option [value]="2">2</mat-option>
                                                    <mat-option [value]="2.25">2.25</mat-option>
                                                    <mat-option [value]="2.5">2.5</mat-option>
                                                    <mat-option [value]="2.75">2.75</mat-option>
                                                    <mat-option [value]="3">3</mat-option>
                                                    <mat-option [value]="3.25">3.25</mat-option>
                                                    <mat-option [value]="3.5">3.5</mat-option>
                                                    <mat-option [value]="3.75">3.75</mat-option>
                                                    <mat-option [value]="4">4</mat-option>
                                                    <mat-option [value]="4.25">4.25</mat-option>
                                                    <mat-option [value]="4.5">4.5</mat-option>
                                                    <mat-option [value]="4.75">4.75</mat-option>
                                                    <mat-option [value]="5">5</mat-option>
                                                    <mat-option [value]="5.25">5.25</mat-option>
                                                    <mat-option [value]="5.5">5.5</mat-option>
                                                    <mat-option [value]="5.75">5.75</mat-option>
                                                    <mat-option [value]="6">6</mat-option>
                                                    <mat-option [value]="6.25">6.25</mat-option>
                                                    <mat-option [value]="6.5">6.5</mat-option>
                                                    <mat-option [value]="6.75">6.75</mat-option>
                                                    <mat-option [value]="7">7</mat-option>
                                                    <mat-option [value]="8">8</mat-option>
                                                    <mat-option [value]="9">9</mat-option>
                                                    <mat-option [value]="10">10</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Net imposable</mat-label>
                                                <input type="number" step="1000" matInput [(ngModel)]="user.annual_income"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> €</span>
                                                <mat-hint>(Avec foncier actuel)</mat-hint>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-12">
                                            <mat-form-field>
                                                <mat-label>Revenus annuel SCI</mat-label>
                                                <input type="number" step="1000" matInput [(ngModel)]="user.annual_income_sci"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> €</span>
                                                <mat-hint>Revenus de votre SCI (optionnel)</mat-hint>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="card block" [class.card-locked]="!authenticationService.isAllowed('pro')">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h2>Chasseurs immobilier</h2>
                                    </div>
                                </div>
                                <div class="locked-overlay" *ngIf="!authenticationService.isAllowed('pro')">
                                    <button type="button" class="btn btn-primary" (click)="openUpgrade()">Débloquer cette fonctionnalité</button>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Frais de chasse <i class="fa fa-info-circle" matTooltip="Renseignez ici la liste des autres frais liés à cet achat : Chasseur immobilier, architecte, maître d'œuvre, géomètre ..."></i></mat-label>
                                                <input type="number" step="0.5" matInput [(ngModel)]="user.other_fees"
                                                       [disabled]="!authenticationService.isAllowed('pro')"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> %</span>
                                                <mat-hint>Montant calculé sur le prix d'achat</mat-hint>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Montant minimum</mat-label>
                                                <input type="number" step="100" matInput [(ngModel)]="user.other_fees_min"
                                                       [disabled]="!authenticationService.isAllowed('pro')"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> €</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-12">
                                            <h4>
                                                Travaux
                                            </h4>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Architecte / Maîtrise d'œuvre</mat-label>
                                                <input type="number" step="0.5" matInput [(ngModel)]="user.other_fees_work"
                                                       [disabled]="!authenticationService.isAllowed('pro')"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> %</span>
                                                <mat-hint>Montant calculé sur le total des travaux</mat-hint>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Montant minimum</mat-label>
                                                <input type="number" step="100" matInput [(ngModel)]="user.other_fees_work_min"
                                                       [disabled]="!authenticationService.isAllowed('pro')"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> €</span>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="colWidget col-md-12"
                     [stepContent]="userAmmortStepContent"
                     [joyrideStep]="'userAmmortStep'">
                    <div class="card block">
                        <div class="card-header">
                            <div class="card-title">
                                <h2>Amortissement</h2>
                            </div>
                        </div>
                        <div class="card-body col-md-12">
                            <div class="card-text row">
                                <h3 class="mb-3">Non amortissable</h3>
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Terrain</mat-label>
                                        <input type="number" step="1" matInput [(ngModel)]="user.part_field"
                                               (ngModelChange)="edit($event)">
                                        <span matSuffix> %</span>
                                    </mat-form-field>
                                </div>

                                <h3 class="mb-3">Amortissable</h3>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Meubles</mat-label>
                                                <input matInput disabled value="Réel">
                                                <span matSuffix> €</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Durée</mat-label>
                                                <input type="number" step="1" matInput
                                                       [(ngModel)]="user.amort_duration_furniture"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> ans</span>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Frais d'agence</mat-label>
                                                <input matInput disabled value="Réel">
                                                <span matSuffix> €</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Durée</mat-label>
                                                <input type="number" step="1" matInput
                                                       [(ngModel)]="user.amort_duration_agency_fees"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> ans</span>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Gros œuvre</mat-label>
                                                <input type="number" step="1" matInput [(ngModel)]="user.part_structure"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> %</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Durée</mat-label>
                                                <input type="number" step="1" matInput
                                                       [(ngModel)]="user.amort_duration_structure"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> ans</span>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Équipements</mat-label>
                                                <input type="number" step="1" matInput [(ngModel)]="user.part_equipment"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> %</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Durée</mat-label>
                                                <input type="number" step="1" matInput
                                                       [(ngModel)]="user.amort_duration_equipment"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> ans</span>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Travaux</mat-label>
                                                <input matInput disabled value="Réel">
                                                <span matSuffix> €</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Durée</mat-label>
                                                <input type="number" step="1" matInput [(ngModel)]="user.amort_duration_work"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> ans</span>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Façades et étanchéité</mat-label>
                                                <input type="number" step="1" matInput [(ngModel)]="user.part_facade"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> %</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Durée</mat-label>
                                                <input type="number" step="1" matInput [(ngModel)]="user.amort_duration_facade"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> ans</span>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Agencements</mat-label>
                                                <input type="number" step="1" matInput [(ngModel)]="user.part_arrangment"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> %</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Durée</mat-label>
                                                <input type="number" step="1" matInput
                                                       [(ngModel)]="user.amort_duration_arrangment"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> ans</span>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Onboarding -->
<joyrideStep [stepContent]="introStepContent"
             joyrideStep="introStep"
             stepPosition="center">
</joyrideStep>
<ng-template #introStepContent>
    <div class="user_onboarding_content">
        <h2>Personnaliser vos préférences</h2>
        <p>
            Félicitations, vous arrivez au bout des 9 étapes pour démarrer avec LyBox !<br/>
            <br/>
            Vous êtes bientôt un expert de l’application, et en tant qu’expert, vous allez pouvoir paramétrer LyBox
            pour qu’il s’adapte à votre stratégie d’investissement !
        </p>
    </div>
</ng-template>

<ng-template #userDefaultStepContent>
    <div class="user_onboarding_content">
        <h2>Personnaliser vos préférences</h2>
        <p>
            Vous pouvez ici choisir <b>les frais de gestion</b> par agence et de <b>Garantie Loyer Impayés</b>
            (GLI).<br/>
            Ces valeurs seront utilisées automatiquement pour calculer le <b>rendement net</b> de chaque annonce
            dans vos recherches.<br/>
            <br/>
            Vous pouvez aussi choisir <b>les ratios de prix/m² de travaux</b> pour faire des estimations rapides !
        </p>
    </div>
</ng-template>

<ng-template #userFinanceStepContent>
    <div class="user_onboarding_content">
        <h2>Personnaliser vos préférences</h2>
        <p>
            Place au <b>financement</b> !<br/>
            <br/>
            Renseignez ici <b>l’apport</b> que vous voulez mettre sur chaque projet, mais aussi la <b>durée</b> et
            le <b>taux de votre crédit</b>.<br/>
            <br/>
            Ces valeurs seront utilisées automatiquement pour calculer le <b>cash-flow</b> de chaque annonce dans
            vos recherches.
        </p>
    </div>
</ng-template>

<ng-template #userFiscaStepContent>
    <div class="user_onboarding_content">
        <h2>Personnaliser vos préférences</h2>
        <p>
            Maintenant, la fiscalité<br/>
            <br/>
            Vous pouvez renseigner le <b>régime fiscal</b> à utiliser par défaut, ainsi que vos informations
            personnelles pour que nous puissions calculer votre fiscalité.<br/>
            <br/>
            Le régime fiscal sera toujours modifiable dans vos simulations
        </p>
    </div>
</ng-template>

<ng-template #userAmmortStepContent>
    <div class="user_onboarding_content">
        <h2>Personnaliser vos préférences</h2>
        <p>
            Dans le cadre du <b>LMNP</b> ou de la <b>SCI à l’IS</b>, vous allez pratiquer des <b>amortissements
            comptables</b> pour calculer le montant des impôts sur votre projet.<br/>
            <br/>
            Les durées et les montants de chacun de ces amortissements sont modifiables ici.<br/>
            <br/>
            Les valeurs par défaut sont celles utilisées par la plupart des comptables, donc vous pouvez aussi
            laisser ces valeurs 🙂<br/>
        </p>
    </div>
</ng-template>
